import { useLocation } from 'wouter';
import { useMarket } from '@/lib/market-context';
import { germanyPath, GERMANY_ORIGIN, SWISS_ORIGIN } from '@/lib/markets';

export default function CountrySwitcher() {
  const [path] = useLocation();
  const { germany } = useMarket();
  return <div className="hp-country-switch">
    <h3 className="hp-h6">{path.startsWith('/en/') ? 'Countries' : 'Länder'}</h3>
    <ul>
      <li><a href={SWISS_ORIGIN + path} aria-current={!germany ? 'true' : undefined}>Schweiz</a></li>
      <li><a href={GERMANY_ORIGIN + germanyPath(path)} aria-current={germany ? 'true' : undefined}>Deutschland</a></li>
    </ul>
  </div>;
}
